import { render, staticRenderFns } from "./PushInboxPanel.vue?vue&type=template&id=63b7322a&scoped=true"
import script from "./PushInboxPanel.vue?vue&type=script&lang=js"
export * from "./PushInboxPanel.vue?vue&type=script&lang=js"
import style0 from "./PushInboxPanel.vue?vue&type=style&index=0&id=63b7322a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7322a",
  null
  
)

export default component.exports